import { c as _c } from "react/compiler-runtime";
// First booklet page (POC .nav): the scope picker, views, the session row (opens Settings). The board filter is a
// sheet (components/filters.tsx) behind the board's floating pill.
// Look (Plan nav-filters): single-word labels, segmented controls, frosted sticky section heads, muted counts, no
// heavy outlines. Every control writes the URL (lib/filter.ts); nothing here keeps its own filter state.
import { useTranslation } from "react-i18next";
import { NavLink, useLocation, useSearchParams } from "react-router";
import type { Project, Snapshot } from "@/api";
import { type View, VIEW_PATH, VIEWS } from "@/lib/views";
import { Icon } from "@/components/icon";
import { Initials } from "@/components/initials";
import { LinkButton } from "@/components/link-button";
import { Row } from "@/components/row";
import { type BoardFilter, parseFilter, writeFilter } from "@/lib/filter";
import { useBoardFilter, useMobile } from "@/lib/hooks";
import { useAuth, useData } from "@/store";
import { ErrorLine } from "@/components/error-line";
import { Dot } from "@/components/dot";
import { useViews } from "@/views";
type Props = {
  snapshot: Snapshot | null;
  filter: BoardFilter;
  settings: boolean;
  onSettings: () => void;
};
export function Nav(t0) {
  const $ = _c(88);
  const {
    snapshot,
    filter,
    settings,
    onSettings
  } = t0;
  const {
    t
  } = useTranslation();
  const {
    search
  } = useLocation();
  const me = useAuth(_temp);
  const error = useData(_temp2);
  const live = useData(_temp3);
  const mobile = useMobile();
  const [, setParams] = useSearchParams();
  let t1;
  if ($[0] !== filter || $[1] !== snapshot?.projects) {
    t1 = snapshot?.projects.find(p => p.id === filter.project);
    $[0] = filter;
    $[1] = snapshot?.projects;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const current = t1;
  const home = useAuth(_temp4);
  const t2 = useViews();
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[3] !== current || $[4] !== home || $[5] !== live || $[6] !== mobile || $[7] !== search || $[8] !== setParams || $[9] !== snapshot || $[10] !== t || $[11] !== t2) {
    const extra = t2.flatMap(_temp5);
    t8 = "nav flex flex-col";
    t9 = "nav";
    t10 = "nav";
    t11 = "Nav";
    t12 = !snapshot || undefined;
    let t16;
    if ($[25] !== t) {
      t16 = t("app.title");
      $[25] = t;
      $[26] = t16;
    } else {
      t16 = $[26];
    }
    let t17;
    if ($[27] !== live) {
      t17 = <Dot t="live" live={live} />;
      $[27] = live;
      $[28] = t17;
    } else {
      t17 = $[28];
    }
    if ($[29] !== t16 || $[30] !== t17) {
      t13 = <h2 className="brand">{t16}{t17}</h2>;
      $[29] = t16;
      $[30] = t17;
      $[31] = t13;
    } else {
      t13 = $[31];
    }
    let t18;
    if ($[32] !== current) {
      t18 = current ? <SpaceIcon type={current.type} /> : <Initials name={"∗"} />;
      $[32] = current;
      $[33] = t18;
    } else {
      t18 = $[33];
    }
    let t19;
    if ($[34] !== current?.name || $[35] !== t) {
      t19 = current?.name ?? t("scope.all");
      $[34] = current?.name;
      $[35] = t;
      $[36] = t19;
    } else {
      t19 = $[36];
    }
    let t20;
    if ($[37] !== t19) {
      t20 = <span className="name">{t19}</span>;
      $[37] = t19;
      $[38] = t20;
    } else {
      t20 = $[38];
    }
    let t21;
    if ($[39] !== current || $[40] !== home) {
      t21 = current && <span className="sub mono">{current.instance ?? home}</span>;
      $[39] = current;
      $[40] = home;
      $[41] = t21;
    } else {
      t21 = $[41];
    }
    let t22;
    if ($[42] !== t20 || $[43] !== t21) {
      t22 = <>{t20}{t21}</>;
      $[42] = t20;
      $[43] = t21;
      $[44] = t22;
    } else {
      t22 = $[44];
    }
    const t23 = mobile ? undefined : "scope-menu";
    let t24;
    if ($[45] !== mobile || $[46] !== setParams) {
      t24 = mobile ? () => setParams(_temp6, {
        replace: true
      }) : undefined;
      $[45] = mobile;
      $[46] = setParams;
      $[47] = t24;
    } else {
      t24 = $[47];
    }
    if ($[48] !== t18 || $[49] !== t22 || $[50] !== t23 || $[51] !== t24) {
      t14 = <Row t="scope" className="picker" lead={t18} label={t22} chevron={true} popoverTarget={t23} onClick={t24} />;
      $[48] = t18;
      $[49] = t22;
      $[50] = t23;
      $[51] = t24;
      $[52] = t14;
    } else {
      t14 = $[52];
    }
    if ($[53] !== mobile) {
      t15 = !mobile && <div id="scope-menu" popover="auto" className="scope-menu" data-t="scope-menu"><Projects menu="scope-menu" /></div>;
      $[53] = mobile;
      $[54] = t15;
    } else {
      t15 = $[54];
    }
    t3 = "rows views";
    t4 = "views";
    if ($[55] !== t) {
      t5 = t("nav.views");
      $[55] = t;
      $[56] = t5;
    } else {
      t5 = $[56];
    }
    if ($[57] !== search || $[58] !== t) {
      t6 = VIEWS.map(v_0 => <li key={v_0}><NavLink to={{
          pathname: VIEW_PATH[v_0],
          search: v_0 === "board" || v_0 === "graph" || v_0 === "secrets" ? keepFilter(search) : ""
        }} end={true} className="row" data-t="view" data-view={v_0}><Icon name={v_0} /><span className="label">{t(`nav.${v_0}`)}</span></NavLink></li>);
      $[57] = search;
      $[58] = t;
      $[59] = t6;
    } else {
      t6 = $[59];
    }
    t7 = extra.map(_temp7);
    $[3] = current;
    $[4] = home;
    $[5] = live;
    $[6] = mobile;
    $[7] = search;
    $[8] = setParams;
    $[9] = snapshot;
    $[10] = t;
    $[11] = t2;
    $[12] = t10;
    $[13] = t11;
    $[14] = t12;
    $[15] = t13;
    $[16] = t14;
    $[17] = t15;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t10 = $[12];
    t11 = $[13];
    t12 = $[14];
    t13 = $[15];
    t14 = $[16];
    t15 = $[17];
    t3 = $[18];
    t4 = $[19];
    t5 = $[20];
    t6 = $[21];
    t7 = $[22];
    t8 = $[23];
    t9 = $[24];
  }
  let t16;
  if ($[60] !== t3 || $[61] !== t4 || $[62] !== t5 || $[63] !== t6 || $[64] !== t7) {
    t16 = <ul className={t3} data-t={t4} aria-label={t5}>{t6}{t7}</ul>;
    $[60] = t3;
    $[61] = t4;
    $[62] = t5;
    $[63] = t6;
    $[64] = t7;
    $[65] = t16;
  } else {
    t16 = $[65];
  }
  let t17;
  if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className="flex-1" />;
    $[66] = t17;
  } else {
    t17 = $[66];
  }
  let t18;
  if ($[67] !== error) {
    t18 = error && <ErrorLine>{error}</ErrorLine>;
    $[67] = error;
    $[68] = t18;
  } else {
    t18 = $[68];
  }
  const t19 = me?.name ?? "?";
  let t20;
  if ($[69] !== t19) {
    t20 = <Initials name={t19} />;
    $[69] = t19;
    $[70] = t20;
  } else {
    t20 = $[70];
  }
  const t21 = me?.name ?? "…";
  let t22;
  if ($[71] !== onSettings || $[72] !== settings || $[73] !== t20 || $[74] !== t21) {
    t22 = <Row t="session" className="session" lead={t20} label={t21} chevron={true} aria-expanded={settings} onClick={onSettings} />;
    $[71] = onSettings;
    $[72] = settings;
    $[73] = t20;
    $[74] = t21;
    $[75] = t22;
  } else {
    t22 = $[75];
  }
  let t23;
  if ($[76] !== t10 || $[77] !== t11 || $[78] !== t12 || $[79] !== t13 || $[80] !== t14 || $[81] !== t15 || $[82] !== t16 || $[83] !== t18 || $[84] !== t22 || $[85] !== t8 || $[86] !== t9) {
    t23 = <section className={t8} data-t={t9} data-page={t10} aria-label={t11} aria-busy={t12}>{t13}{t14}{t15}{t16}{t17}{t18}{t22}</section>;
    $[76] = t10;
    $[77] = t11;
    $[78] = t12;
    $[79] = t13;
    $[80] = t14;
    $[81] = t15;
    $[82] = t16;
    $[83] = t18;
    $[84] = t22;
    $[85] = t8;
    $[86] = t9;
    $[87] = t23;
  } else {
    t23 = $[87];
  }
  return t23;
}

/** The project list of the scope picker: the desktop card (`menu` = its popover id, rows close it) or the phone
 *  Sheet (a pick sets ?project= and drops ?scope= in one step, so the sheet slides away). */
function _temp7(n) {
  return <li key={n.path}><NavLink to={n.path} end={true} className="row" data-t="view" data-view={n.path.slice(1)}><Icon d={n.icon} /><span className="label">{n.label()}</span></NavLink></li>;
}
function _temp6(p_0) {
  return p_0.set("scope", "1"), p_0;
}
function _temp5(v) {
  return v.nav ?? [];
}
function _temp4(s_2) {
  return s_2.instance;
}
function _temp3(s_1) {
  return s_1.live;
}
function _temp2(s_0) {
  return s_0.error;
}
function _temp(s) {
  return s.me;
}
export function Projects(t0) {
  const $ = _c(18);
  const {
    menu
  } = t0;
  const {
    t
  } = useTranslation();
  const snapshot = useData(_temp8);
  const [filter] = useBoardFilter();
  const [, setParams] = useSearchParams();
  const all = snapshot?.projects ?? [];
  const hasKids = new Set(all.map(_temp9));
  const projects = all.filter(p_0 => p_0.status !== "archived" || p_0.id === filter.project || hasKids.has(p_0.id));
  let t1;
  if ($[0] !== setParams) {
    t1 = id => setParams(p_1 => {
      const q = writeFilter(p_1, {
        ...parseFilter(p_1),
        project: id
      });
      q.delete("scope");
      return q;
    }, {
      replace: true
    });
    $[0] = setParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const pick = t1;
  let t2;
  if ($[2] !== menu) {
    t2 = menu ? {
      popoverTarget: menu,
      popoverTargetAction: "hide" as const
    } : {};
    $[2] = menu;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const close = t2;
  const home = useAuth(_temp0);
  const groups = [...new Set(projects.map(_temp1))];
  const t3 = "rows scope-list";
  const t4 = "projects";
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Initials name={"∗"} />;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t) {
    t6 = t("scope.all");
    $[5] = t;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = filter.project ? undefined : "✓";
  const t8 = !filter.project;
  let t9;
  if ($[7] !== pick) {
    t9 = () => pick(null);
    $[7] = pick;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== close || $[10] !== t6 || $[11] !== t7 || $[12] !== t8 || $[13] !== t9) {
    t10 = <li><Row t="project" lead={t5} label={t6} count={t7} aria-pressed={t8} {...close} onClick={t9} /></li>;
    $[9] = close;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  const t11 = groups.map(inst => <li key={inst ?? ""}><details open={true} className="scope-group" data-t="instance" data-id={inst ?? home ?? ""}><summary className="section-head"><span>{inst ?? home ?? ""}</span><span className="chev" aria-hidden={true}>{"›"}</span></summary><SpaceTree spaces={projects.filter(p_3 => p_3.instance === inst)} parent={null} picked={filter.project} close={close} pick={pick} /></details></li>);
  let t12;
  if ($[15] !== t10 || $[16] !== t11) {
    t12 = <ul className={t3} data-t={t4}>{t10}{t11}</ul>;
    $[15] = t10;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  return t12;
}
function _temp1(p_2) {
  return p_2.instance;
}
function _temp0(s_0) {
  return s_0.instance;
}
function _temp9(p) {
  return p.parent;
}
function _temp8(s) {
  return s.snapshot;
}
type SpaceProps = {
  spaces: Project[];
  parent: string | null;
  picked: string | null;
  close: {
    popoverTarget?: string;
    popoverTargetAction?: "hide";
  };
  pick: (id: string) => void;
};

/** One level of a space tree (spaces in the core's tree order): a space's row, then its children in a native
 *  <details> whose summary is the chevron beside the row (collapse is CSS). A stub ancestor is a plain row, no pick. */
function SpaceTree(t0) {
  const $ = _c(19);
  const {
    spaces,
    parent,
    picked,
    close,
    pick
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] !== close || $[1] !== parent || $[2] !== pick || $[3] !== picked || $[4] !== spaces) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      let t4;
      if ($[8] !== parent || $[9] !== spaces) {
        t4 = p => p.parent === parent || parent === null && !spaces.some(x => x.id === p.parent);
        $[8] = parent;
        $[9] = spaces;
        $[10] = t4;
      } else {
        t4 = $[10];
      }
      const level = spaces.filter(t4);
      if (!level.length) {
        t3 = null;
        break bb0;
      }
      t1 = "rows";
      let t5;
      if ($[11] !== close || $[12] !== pick || $[13] !== picked || $[14] !== spaces) {
        t5 = p_0 => {
          const kids = spaces.some(x_0 => x_0.parent === p_0.id);
          return <li key={p_0.id} className="space">{p_0.stub ? <div className="row stub" data-t="space-stub" data-id={p_0.id}><SpaceIcon type={p_0.type} /><span className="label">{p_0.name}</span></div> : <Row t="project" id={p_0.id} lead={<SpaceIcon type={p_0.type} />} label={p_0.name} count={picked === p_0.id ? "✓" : p_0.open} aria-pressed={picked === p_0.id} {...close} onClick={() => pick(p_0.id)} />}{kids && <details open={true}><summary aria-label={p_0.name}><span className="chev" aria-hidden={true}>{"›"}</span></summary><SpaceTree spaces={spaces} parent={p_0.id} picked={picked} close={close} pick={pick} /></details>}</li>;
        };
        $[11] = close;
        $[12] = pick;
        $[13] = picked;
        $[14] = spaces;
        $[15] = t5;
      } else {
        t5 = $[15];
      }
      t2 = level.map(t5);
    }
    $[0] = close;
    $[1] = parent;
    $[2] = pick;
    $[3] = picked;
    $[4] = spaces;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  let t4;
  if ($[16] !== t1 || $[17] !== t2) {
    t4 = <ul className={t1}>{t2}</ul>;
    $[16] = t1;
    $[17] = t2;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  return t4;
}

/** A space's type as its icon in the lead circle (truss Space.type: org, team, project, personal). */
function SpaceIcon(t0) {
  const $ = _c(5);
  const {
    type
  } = t0;
  let t1;
  if ($[0] !== type) {
    t1 = <Icon name={type} size={14} />;
    $[0] = type;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1 || $[3] !== type) {
    t2 = <span className="initials space-icon" data-type={type} aria-hidden={true}>{t1}</span>;
    $[2] = t1;
    $[3] = type;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}

/** Board filter params only: panel params (?thread=, ?pkg=) stay with their page. */
function keepFilter(search: string) {
  const q = new URLSearchParams(search);
  for (const k of [...q.keys()]) if (!["who", "project", "show", "q", "id", "settings"].includes(k)) q.delete(k);
  const s = q.toString();
  return s ? `?${s}` : "";
}